import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=13798e2a&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13798e2a')) {
      api.createRecord('13798e2a', component.options)
    } else {
      api.reload('13798e2a', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=13798e2a&", function () {
      api.rerender('13798e2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bI27SHJhlNcx/JS/offershelp.vue"
export default component.exports